if (!customElements.get('storm-infinite-scroll')) {
  customElements.define('storm-infinite-scroll', class extends HTMLElement {
    connectedCallback() {
      this.link = this.querySelector('[data-next-page]');
      this.status = this.querySelector('[role="status"]');
      this.grid = this.closest('#ProductGridContainer')?.querySelector('#product-grid');
      if (!this.link || !this.grid || !('IntersectionObserver' in window)) return;
      this.abort = new AbortController();
      this.next = this.link.href;
      this.seen = new Set();
      this.querySelector('[data-pagination-fallback]').hidden = true;
      this.link.addEventListener('click', event => {
        event.preventDefault();
        this.failed = false;
        this.load();
      }, { signal: this.abort.signal });
      this.observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting) && !this.failed) this.load();
      }, { rootMargin: '0px 0px 500px 0px' });
      this.observer.observe(this);
    }

    async load() {
      if (this.busy || !this.next || !this.isConnected || this.closest('.collection.loading')) return;
      const next = this.next;
      if (this.seen.has(next)) return;
      const locationAtStart = window.location.href;
      this.busy = true;
      this.setAttribute('aria-busy', 'true');
      this.status.textContent = 'Ürünler yükleniyor…';
      this.link.setAttribute('aria-disabled', 'true');
      try {
        const url = new URL(next, window.location.origin);
        if (url.origin !== window.location.origin) throw new Error('Invalid pagination origin');
        url.searchParams.set('section_id', this.dataset.section);
        const response = await fetch(url, { signal: this.abort.signal });
        if (!response.ok) throw new Error(`Pagination HTTP ${response.status}`);
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (!this.isConnected || window.location.href !== locationAtStart || this.closest('.collection.loading')) return;
        const nextGrid = html.querySelector('#product-grid');
        const cards = nextGrid ? [...nextGrid.children] : [];
        if (!cards.length) throw new Error('Missing product page');
        cards.forEach(card => {
          card.classList.add('scroll-trigger--cancel');
          card.querySelectorAll('.scroll-trigger').forEach(el => el.classList.add('scroll-trigger--cancel'));
        });
        this.grid.append(...cards);
        this.seen.add(next);
        this.next = html.querySelector('storm-infinite-scroll [data-next-page]')?.getAttribute('href') || '';
        this.status.textContent = this.next ? `${cards.length} ürün daha yüklendi.` : 'Tüm ürünler gösteriliyor.';
        if (this.next) {
          this.link.href = this.next;
          this.link.textContent = 'Daha fazla ürün göster';
          this.observer.unobserve(this);
          this.observer.observe(this);
        } else {
          this.link.hidden = true;
          this.observer.disconnect();
        }
      } catch (error) {
        if (error.name !== 'AbortError' && this.isConnected) {
          this.failed = true;
          this.status.textContent = 'Ürünler yüklenemedi. Tekrar deneyebilirsiniz.';
          this.link.textContent = 'Tekrar dene';
          this.querySelector('[data-pagination-fallback]').hidden = false;
        }
      } finally {
        this.busy = false;
        this.removeAttribute('aria-busy');
        this.link.removeAttribute('aria-disabled');
      }
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
    }
  });
}
